import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import TextInput from "../../../components/TextInputs";

const StepOne = ({ businessName, setBusinessName }) => {
  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={4.5}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Account Setup
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "30px", marginBottom: "15px" }}
          >
            What's your business name?
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "15px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            This is the brand name your clients will see. Your billing and legal
            name can be added later.
          </Typography>
          <Box
            sx={{
              padding: "25px",
              border: "1px solid rgb(178 181 178)",
              borderRadius: "15px",
            }}
          >
            <TextInput
              required={true}
              placeholder={"Business Name"}
              type={"text"}
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepOne;
